import UserResource from "../../../../Domain/User/ApiResources/UserResource";

export default class ApiDataSource {

    async get() {
        let response = await new UserResource().getLoggedInUser();
        return response ? response.data : null;
    }

}
